import { render, staticRenderFns } from "./zoomgambar.vue?vue&type=template&id=97a6d33a&"
import script from "./zoomgambar.vue?vue&type=script&lang=js&"
export * from "./zoomgambar.vue?vue&type=script&lang=js&"
import style0 from "./zoomgambar.vue?vue&type=style&index=0&id=97a6d33a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports